// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay_overlay__MOLmb"};